import { z } from "zod";

/** Mirrors the Prisma `MemberRole` enum, highest first. */
export const memberRoleSchema = z.enum(["OWNER", "EDITOR", "REVIEWER", "VIEWER"]);
export type MemberRole = z.infer<typeof memberRoleSchema>;

export const ROLE_LABELS: Record<MemberRole, { label: string; can: string }> = {
  OWNER: { label: "Owner", can: "Everything, including members, brands and budgets" },
  EDITOR: { label: "Editor", can: "Create and edit content and knowledge, start agents" },
  REVIEWER: { label: "Reviewer", can: "Read, and approve or reject what agents made" },
  VIEWER: { label: "Viewer", can: "Read only" },
};

export const membershipStatusSchema = z.enum(["INVITED", "ACTIVE"]);
export type MembershipStatus = z.infer<typeof membershipStatusSchema>;

/** URL-safe identifier for workspaces and brands: lower case, digits, single hyphens. */
export const handleSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(2)
  .max(40)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, { message: "Use lower case letters, digits and hyphens" });

/** Piece-code prefix, e.g. "fr" in fr-li-0001. */
export const codePrefixSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z]{2,4}$/, { message: "Use 2–4 letters" });

const isTimeZone = (value: string) => {
  try {
    new Intl.DateTimeFormat("en", { timeZone: value });
    return true;
  } catch {
    return false;
  }
};

export const timeZoneSchema = z
  .string()
  .trim()
  .refine(isTimeZone, { message: "Use an IANA time zone like Australia/Melbourne" });

/** Money limits, in US dollars. */
export const usdSchema = z.coerce.number().min(0).max(10_000);
